var styleDataHash = "be901fc1";
const injectCss = (() => {
  var css = `.eveB7{height:18px;position:relative;width:18px}.I6Eej,.UBfhe{height:100%;left:0;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}.I6Eej{animation:NhxGH 666ms linear infinite;opacity:.3}.I6Eej,.UBfhe{stroke:currentColor}.UBfhe{animation:NhxGH 2s linear infinite}@keyframes NhxGH{to{transform:rotate(1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var double_loader_default = {
  "wrapper": "eveB7",
  "top": "I6Eej",
  "bottom": "UBfhe",
  "rotation": "NhxGH"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
